import {readFragmentFromCache} from 'graphql-client/ApolloWrappers';
import FragmentWrapper from 'graphql-client/FragmentWrapper';
import {ProcessTaskSchema} from 'processes/ProcessConstants';
import {PROCESS_TASK_SCHEMA_FRAGMENT} from 'processes/ProcessFragments';

const ProcessTaskSchemaFragment: FragmentWrapper<ProcessTaskSchema> = {
  fragment: PROCESS_TASK_SCHEMA_FRAGMENT,
  fragmentName: 'ProcessTaskSchema',
};

export default function readProcessTaskSchemaFromCache(schemaId: string): ProcessTaskSchema | null {
  return readFragmentFromCache(ProcessTaskSchemaFragment, schemaId);
}
